import * as React from 'react';
import { Elided } from './CSSMacros';

export const DefaultFormatter: React.FC<{ value: any, testId: string }> = props => {
  const [tooltip, setTooltip] = React.useState<string | undefined>(undefined);

  const handleMouseEnter: React.MouseEventHandler<HTMLElement> = e => {
    if (e.currentTarget.clientWidth < e.currentTarget.scrollWidth) {
      setTooltip(e.currentTarget.textContent || undefined);
    }
  }

  return <div
    children={props.value}
    data-tb-test-id={props.testId}
    onMouseEnter={handleMouseEnter}
    style={Elided}
    title={tooltip}
  />
}
DefaultFormatter.displayName = 'DataGridDefaultFormatter';
